import { create } from 'zustand';

export interface IPilotageStore {
    hasObservation: boolean;
    hasChanges: boolean;
    setHasObservation: (data: boolean) => void;
    setHasChanges: (data: boolean) => void;
}

export const createPilotageStore = () =>
    create<IPilotageStore>((set) => ({
        hasObservation: false,
        hasChanges: false,
        setHasObservation: (data) => set({ hasObservation: data }),
        setHasChanges: (data) => set({ hasChanges: data }),
    }));
